import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="py-24 bg-white relative overflow-hidden" data-id="element-100">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-sage-light/20 rounded-full blur-3xl -z-10" data-id="element-101" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-102">
        <FadeIn data-id="element-103">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-104">
            Recupera el control de tu cuerpo hoy mismo.
          </h2>
          <p className="text-xl text-brown/70 mb-12" data-id="element-105">
            Sin suscripciones mensuales, sin apps complicadas. Un solo pago para
            el manual que tu cuerpo ha estado pidiendo a gritos.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-106">
          <div className="bg-cream rounded-[2.5rem] p-8 md:p-12 border border-sage-light shadow-xl relative max-w-2xl mx-auto" data-id="element-107">
            <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-32 h-40" data-id="element-108">
              <img src="https://cdn.magicpatterns.com/uploads/4xnujm8VD2ap5cfuuq1GHN/protocolo_cortisol.png" alt="Protocolo Cortisol Off" className="w-full h-full object-contain drop-shadow-lg" data-id="element-109" />
            </div>

            <div id="precio" className="pt-20 mb-8 scroll-mt-24" data-id="element-110">
              <div className="text-sm font-bold tracking-widest text-sage uppercase mb-2" data-id="element-111">
                Precio Especial de Lanzamiento
              </div>
              <div className="text-6xl font-serif font-bold text-brown" data-id="element-112">
                $10.99 <span className="text-2xl text-brown/60" data-id="element-113">USD</span>
              </div>
            </div>

            <CTAButton href="https://www.luminahabit.com/cart/47297614217469:1" className="w-full mb-6" data-id="element-114">
              Descargar
            </CTAButton>

            <div className="flex items-center justify-center text-sm text-brown/60" data-id="element-115">
              <ShieldCheckIcon className="w-4 h-4 mr-2 text-sage" data-id="element-116" />
              Compra segura con acceso instantáneo. Comienza a desinflamarte
              hoy.
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}